import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Current navigation
  fromRoute: null,
  toRoute: null,
  
  // Navigation stack (breadcrumb trail)
  navigationStack: [],  // Stores [{ from, to, fromName, toName, timestamp }]
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    // Called when navigating from one page to another
    pushNavigation: (state, action) => {
      const { from, to, fromName, toName } = action.payload;
      
      // Update current navigation
      state.fromRoute = from;
      state.toRoute = to;
      
      // Push to navigation stack (add to beginning)
      state.navigationStack.unshift({
        from,
        to,
        fromName,
        toName,
        timestamp: Date.now()
      });
      
      // Keep only last 20 entries
      if (state.navigationStack.length > 20) {
        state.navigationStack.pop();
      }
    },
    
    // Called when going back to previous page
    popNavigation: (state) => {
      // Remove the last navigation entry
      if (state.navigationStack.length > 0) {
        const lastNav = state.navigationStack[0];
        state.fromRoute = lastNav.from;
        state.toRoute = lastNav.to;
        state.navigationStack.shift();
      }
    },
    
    // Clear everything on logout
    clearNavigation: (state) => {
      state.fromRoute = null;
      state.toRoute = null;
      state.navigationStack = [];
    },
    
    // Alias for clearNavigation (for backward compatibility)
    clearAllNavigation: (state) => {
      state.fromRoute = null;
      state.toRoute = null;
      state.navigationStack = [];
    },
    
    // Alias for popNavigation
    clearNavigationState: (state) => {
      if (state.navigationStack.length > 0) {
        state.navigationStack.shift();
      }
    },
    
    // For backward compatibility with existing code
    setNavigation: (state, action) => {
      const { from, to, fromName, toName } = action.payload;
      state.fromRoute = from;
      state.toRoute = to;
      state.navigationStack.unshift({
        from,
        to,
        fromName,
        toName,
        timestamp: Date.now()
      });
    },
    
    clearImmediateNavigation: (state) => {
      if (state.navigationStack.length > 0) {
        state.navigationStack.shift();
      }
    },
  },
});

export const { 
  pushNavigation, 
  popNavigation, 
  clearNavigation, 
  clearAllNavigation,
  clearNavigationState,
  setNavigation,
  clearImmediateNavigation
} = navigationSlice.actions;
export default navigationSlice.reducer;